export default __webpack_public_path__ + "static/platform-uses_mobile-bb8fd7e680caa835319801fc6e78cfc3.svg";